import { Outlet } from 'react-router-dom';
import { useNewNotificationToasts } from '@/hooks/useNewNotificationToasts';
import { useNotificationTabTitle } from '@/hooks/useNotificationTabTitle';
import { AdminMobileHeader } from './AdminMobileHeader';
import { AdminMobileNav } from './AdminMobileNav';
import { AdminSidebar } from './AdminSidebar';
import { AdminTopbar } from './AdminTopbar';

export function AdminShell() {
  useNewNotificationToasts();
  useNotificationTabTitle();
  return (
    <div className="h-screen overflow-hidden flex bg-zoooffwhite font-sans">
      <AdminSidebar />
      <div className="flex-1 flex flex-col min-w-0 min-h-0">
        <AdminMobileHeader />
        <AdminTopbar />
        <main className="flex-1 min-h-0 overflow-y-auto pb-24 md:pb-0">
          <Outlet />
        </main>
      </div>
      <AdminMobileNav />
    </div>
  );
}
